export default {
    data(){
        return {
            editedFieldModel: null,
            editedFieldName: null,
            editedFieldRow: null,
            editedFieldPreviousValue: null
        }
    },
    methods: {
        prepareUrlParams: function(data, paramsList = null, commonParamsList = null){
            let params = {};
            let commonParams = {};
            let filtersList = this.$store.getters[this.namespace + '/getFilters'];
            let row = data.node;

            let advancedFilters = filtersList.advancedFilters;
            let reportFilters = filtersList.filters;

            let commonData = {};
            if (reportFilters !== null && reportFilters !== undefined)
            {
                commonData['datesComparison'] = reportFilters.dateComparisonStatus;
                commonData['groupByDate'] = advancedFilters.groupByDate;
                commonData['startDateB'] = reportFilters.dateRange.startDateB;
                commonData['endDateB'] = reportFilters.dateRange.endDateB;
            }

            if (paramsList !== null)
            {
                params = paramsList.reduce(function (acc, item) {
                    if (item !== null && row[item] !== undefined) {
                        acc[item] = row[item];
                    }

                    return acc;
                }, {});
            }

            if (commonParamsList !== null && !(Object.keys(commonData).length === 0 && commonData.constructor === Object))
            {
                commonParams = commonParamsList.reduce(function (acc, item) {
                    if (item !== null && commonData[item] !== undefined && commonData[item] !== null) {
                        acc[item] = commonData[item];
                    }

                    return acc;

                }, {});

                params = Object.assign(commonParams, params);
            }

            if (reportFilters.dateRange !== null && reportFilters.dateRange.dateStart !== null && reportFilters.dateRange.dateEnd !== null)
            {
                params['startDate'] = reportFilters.dateRange.startDate;
                params['endDate'] = reportFilters.dateRange.endDate;
            }

            return params;
        },
        makeColumnEditable: function(columnName, row, value){
            this.editedFieldName = columnName;
            this.editedFieldRow = row;
            this.editedFieldModel = value;
            this.editedFieldPreviousValue = value;
        },
        updateFieldValue: function(){

        },
        cancelEdition: function(){
            this.editedFieldName = null;
            this.editedFieldRow = null;
            this.editedFieldModel = null;
            this.editedFieldPreviousValue = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/mixins/tableColumnViewMixin.js